import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import { TimePicker } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

interface TimeInputProps {
  onTimeChanged: (newtime: string) => void;
  timeString: string;  // Time in 'HH:mm:ss' format
  label?: string;
}

export const TimeInput = (props: TimeInputProps) => {
  const { label, onTimeChanged, timeString } = props;

  // Parse the time string without any timezone assumptions
  // We're just extracting the time components
  const timeParts = timeString.split(':').map(part => parseInt(part, 10));
  const timeValue = DateTime.now().set({
    hour: timeParts[0] || 0,
    minute: timeParts[1] || 0,
    second: timeParts[2] || 0
  });

  const [selectedTime, setSelectedTime] = useState<DateTime>(timeValue);

  useEffect(() => {
    // When timeString prop changes, update the state accordingly
    if (timeString) {
      const parts = timeString.split(':').map(part => parseInt(part, 10));
      const newTime = DateTime.now().set({
        hour: parts[0] || 0,
        minute: parts[1] || 0,
        second: parts[2] || 0
      });
      setSelectedTime(newTime);
    }
  }, [timeString]);

  const handleTimeChange = (time: DateTime | null) => {
    if (time) {
      // Simply format the selected time as HH:mm:ss without timezone conversions - assume in correct format already
      onTimeChanged(time.toFormat('HH:mm:ss'));
      setSelectedTime(time);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <TimePicker
        ampm={false}
        value={selectedTime}
        label={label || ''}
        minutesStep={5}
        onChange={handleTimeChange}
      />
    </LocalizationProvider>
  );
};